import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ColumnModel, IColumnModel } from 'table-editor';

export class LUArmy extends StarbaseEntity implements Serializable<LUArmy> {
    public armyName: string;
    public editable: boolean;
    public editMode: boolean;

    constructor() {
        super();
    }

    public static LUArmyColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
            new ColumnModel('Army Name', 'armyName', 'armyName', editable, 'string', true, true, 100, true),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, true, 50, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, true, 20, false)
        ];
    }

    public static setupArmyCollection(collection: LUArmy[]): void {
        of(collection).pipe(
            map((w: LUArmy[]) =>
                w.map((k: LUArmy) => {
                    k = new LUArmy().deserialize(k);
                })
            )
        ).subscribe();
    }

    deserialize(input) {
        return Object.assign(new LUArmy(), input);
    }
}
